var Iframe_default = {
  "iframe": "Uhd6N"
};
export {
  Iframe_default as default
};
//# sourceMappingURL=Iframe-scss.js.map
